(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('BrickOsfeDialogController', BrickOsfeDialogController);

    BrickOsfeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'BrickOsfe'];

    function BrickOsfeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, BrickOsfe) {
        var vm = this;
        vm.brickOsfe = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:brickOsfeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.brickOsfe.id !== null) {
                BrickOsfe.update(vm.brickOsfe, onSaveSuccess, onSaveError);
            } else {
                BrickOsfe.save(vm.brickOsfe, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
